function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M949.1,238.1l-31.8,31.8L729.7,82.4l31.8-31.8L712.1,1.1L541.8,171.3c-24.6,24.6-43.9,53.4-57.2,85.6  c-13.3,32.2-20.1,66.1-20.1,101v107.3H357.3c-34.8,0-68.8,6.8-101,20.1c-32.2,13.3-61,32.6-85.6,57.2l-170,170l49.5,49.5L82,730.1  l187.5,187.5l-31.8,31.8l49.5,49.5l170-170c24.6-24.6,43.9-53.4,57.2-85.6s20.1-66.1,20.1-101V535.1h107.3c34.8,0,68.8-6.8,101-20.1  s61-32.6,85.6-57.2l170.3-170.3L949.1,238.1z M881.9,305.3L822,365.1L634.5,177.6l59.9-59.9L881.9,305.3z M282.8,550l166.8,166.8  c-9.8,23.5-23.9,44.6-41.9,62.6l-7.6,7.6L212.6,599.5l7.6-7.6C238.2,573.9,259.3,559.8,282.8,550z M117.4,694.7l59.9-59.9  l187.5,187.5l-59.9,59.9L117.4,694.7z M464.5,642.4c0,6-0.3,11.9-0.8,17.8L339.5,536c5.9-0.5,11.8-0.8,17.8-0.8h107.3V642.4z   M534.5,465.1V357.9c0-6.1,0.3-12.2,0.9-18.3L660,464.3c-6,0.6-12.1,0.9-18.3,0.9H534.5z M716.6,450.1l-167-167  c9.8-23.4,23.8-44.3,41.7-62.2l7.9-7.9l187.5,187.5l-7.9,7.9C760.9,426.3,739.9,440.3,716.6,450.1z"
}));

function SvgEpDna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 1002 1002",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpDna);
export default __webpack_public_path__ + "static/media/ep-dna.ac63b008.svg";
export { ForwardRef as ReactComponent };